import { render, staticRenderFns } from "./AuditPanel.vue?vue&type=template&id=720e4a67&scoped=true&"
import script from "./AuditPanel.vue?vue&type=script&lang=js&"
export * from "./AuditPanel.vue?vue&type=script&lang=js&"
import style0 from "./AuditPanel.vue?vue&type=style&index=0&id=720e4a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e4a67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('720e4a67')) {
      api.createRecord('720e4a67', component.options)
    } else {
      api.reload('720e4a67', component.options)
    }
    module.hot.accept("./AuditPanel.vue?vue&type=template&id=720e4a67&scoped=true&", function () {
      api.rerender('720e4a67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/delivery/components/AuditPanel.vue"
export default component.exports